import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски чаршафи от памучен сатен – 100% памук | GoToBed',
  description:
    'Детски чаршафи от памучен сатен, 100% памук. Размери 115/155, 120/200, 150/220, 200/240. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски чаршафи от памучен сатен
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски чаршафи от памучен сатен – 100% памук и различни размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Детските чаршафи от памучен сатен са изработени от 100% памук и се отличават с гладка и
          мека повърхност. Те се изработват по поръчка, което позволява да предложим различни
          размери за бебешки и детски матраци - например 60/120, 70/140, 82/190 и 90/200, като
          чаршафите се изработват в по-големи размери за удобно покриване и подпъхване. Памучният
          сатен е фина и дишаща материя, която осигурява приятно усещане по време на сън.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiCharshafiSaten />;
}

function SeoBodyDetskiCharshafiSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски чаршафи от памучен сатен за детско легло */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски чаршафи от памучен сатен за детско легло
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Детските чаршафи от памучен сатен за детско легло са отличен избор за родители, които търсят
        по-фина и гладка памучна материя за детското спално бельо. Памучният сатен е 100% памучен
        плат, който се отличава с мек допир, гладка повърхност и лек естествен блясък.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски чаршафи от памучен сатен, подходящи за различни размери
        детски легла и матраци. Материята е дишаща и комфортна, което я прави подходяща за ежедневна
        употреба и за чувствителната детска кожа.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички чаршафи се изработват от висококачествени памучни материи със сертификат OEKO-TEX
        Standard 100, което гарантира безопасност и високо качество на текстила.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете пълен комплект детско спално бельо от същия плат, можете да комбинирате
        чаршафа с
      </Typography>
      <Box sx={{ mb: 2, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски калъфки памучен сатен
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        които се изработват от същата висококачествена памучна материя.
      </Typography>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери детски чаршафи от памучен сатен за детско легло */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери детски чаршафи от памучен сатен за детско легло
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите продукти е голямото разнообразие от размери, което
          позволява лесно да намерите подходящ чаршаф за детско легло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме детски чаршафи в размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '115/155',
            '115/180',
            '110/210',
            '120/200',
            '120/220',
            '130/220',
            '140/220',
            '140/240',
            '150/220',
            '150/240',
            '160/220',
            '160/240',
            '170/240',
            '180/220',
            '180/240',
            '200/220',
            '200/240',
            '220/240'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Благодарение на този широк избор можете лесно да намерите подходящ памучен сатен чаршаф за
          детски матрак или детско легло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако предпочитате различна памучна материя, можете да разгледате и нашите
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски чаршафи ранфорс
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          които са изработени от издръжлив 100% памучен плат.
        </Typography>

        {/* H2: Какво представлява памучният сатен? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява памучният сатен?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е 100% памучен плат, който се изработва чрез специален начин на тъкане.
          Благодарение на това материята има по-гладка и фина повърхност.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основни предимства на памучния сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; гладка и мека материя</li>
          <li>&#10004; деликатен естествен блясък</li>
          <li>&#10004; добра дишаемост</li>
          <li>&#10004; комфорт по време на сън</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Детските чаршафи от памучен сатен са отличен избор за родители, които търсят по-фино и
          приятно на допир детско спално бельо.
        </Typography>

        {/* H2: Предимства на нашите детски чаршафи от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите детски чаршафи от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; изработени от 100% памучен сатен</li>
          <li>&#10004; мека и гладка материя</li>
          <li>&#10004; дишащ и комфортен плат</li>
          <li>&#10004; подходящи за детска кожа</li>
          <li>&#10004; голям избор от размери</li>
          <li>&#10004; устойчиви при многократно пране</li>
          <li>&#10004; произведени в България</li>
          <li>&#10004; сертификат OEKO-TEX Standard 100 на платовете</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За пълен комплект детско спално бельо можете да комбинирате чаршафа и с
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски пликове за завивки памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски калъфки за възглавници памучен сатен
          </Typography>
        </Box>

        {/* H2: Свиваемост на памучния плат */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Свиваемост на памучния плат
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тъй като чаршафите са изработени от 100% памук, е възможна естествена свиваемост около
          4–5% след първите пранета. Това е нормално свойство на памучните материи и е характерно за
          всички изделия от естествен памук.
        </Typography>

        {/* H2: Популярни размери детски чаршафи памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери детски чаршафи памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 4 }}>
          <li>чаршаф за детско легло 115/155</li>
          <li>чаршаф за детско легло 115/180</li>
          <li>чаршаф за детско легло 120/200</li>
          <li>чаршаф за детско легло 150/220</li>
          <li>чаршаф за детско легло 160/240</li>
          <li>чаршаф за детско легло 200/240</li>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички детски чаршафи се изработват индивидуално след направена поръчка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски чаршафи памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер детски чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящ чаршаф за детско легло, измерете ширината и дължината на матрака
            и изберете чаршаф със същия или близък размер. В нашия магазин ще откриете детски
            чаршафи в много различни размери, което позволява лесно да намерите подходящия вариант.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е памучният сатен за детско спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Памучният сатен е 100% памучен плат, който е мек, дишащ и приятен на допир. Това го
            прави много подходящ за детско спално бельо и чаршафи за детско легло.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се детските чаршафи от памучен сатен след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от естествен памук, и чаршафите от памучен сатен могат да имат
            естествена свиваемост около 4–5% след първите пранета.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите за различни размери детски легла?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Благодарение на богатия избор от размери можете лесно да намерите подходящ чаршаф за
            различни детски матраци и легла.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват детските чаршафи?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи се изработват в България, специално за всяка поръчка и според избрания
            размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
